import {useTranslation} from "react-i18next";
import {Outlet, useLocation, useNavigate, useParams, useSearchParams} from "react-router-dom";
import {
    Breadcrumb,
    Button,
    Divider,
    Form,
    Input,
    Modal,
    notification,
    Select,
    Space,
    Spin,
    Tooltip,
    Typography
} from "antd";
import React, {useContext, useEffect, useState} from "react";
import DB_OrgStructure from "../../../database/dictionary/org_structures";
import axios from "axios";
import {Context} from "../../../App";
import ModalWindow from "../../modal";
import DB_OrgStructureType from "../../../database/dictionary/org-structure-types";
import DB_Warehouse from "../../../database/dictionary/warehouse";
import DB_PatternActivity from "../../../database/dictionary/pattern-activity";
import {isNullForm} from "../../tech/check";
import {DrawerResponseOrgStructure} from "./drawer_response_org_structure";
import {MobileOutlined, PoweroffOutlined} from "@ant-design/icons";

const EditOrgStructure = () => {
    const {org_structure_id} = useParams()

    const {token, setToken} = useContext(Context);
    const {getOrgStructureTypes} = DB_OrgStructureType(token);
    const {
        getOrgStructure,
        statusOrgStructure,
        createOrgStructure,
        updateOrgStructure,
        getOrgStructureParent,
        getAccessCode
    } = DB_OrgStructure(token);
    const {getActivePatternActivities} = DB_PatternActivity(token);
    const {getActiveWarehouses} = DB_Warehouse(token);
    const {t} = useTranslation();
    const {errorConnect} = ModalWindow();
    const params = useLocation().state;

    const [form] = Form.useForm();

    const navigate = useNavigate();
    const [isLoadSystem, setIsLoadSystem] = useState(true)
    const [wait, setWait] = useState(false);
    const [isActive, setIsActive] = useState()

    const [warehouses, setWarehouses] = useState([]);

    const [patternActivities, setPatternActivities] = useState([]);
    const [orgStructuresType, setOrgStructuresType] = useState([]);
    const [userLevel, setUserLevel] = useState();
    const [parent, setParent] = useState([]);
    const [displayParent, setDisplayParent] = useState(true);
    const [searchParams, setSearchParams] = useSearchParams()
    const [isOpenDrawer, setIsOpenDrawer] = useState(false)
    const [isOpenModalAccessCode, setIsOpenModalAccessCode] = useState(false)


    const StatusButton = () => {
        if(org_structure_id === 'new'){
            return
        }

        return (
            <Tooltip placement="bottomRight" title={isActive ? t('deactivate') : t('activate')}>
                <Button icon={<PoweroffOutlined style={isActive ? {color: 'red'} : {color:'green'}} />} onClick={changeStatus} />
            </Tooltip>
        )
    }

    const GeneratePinCode = () => {
        if(org_structure_id === 'new'){
            return
        }

        return (
            <Tooltip placement="bottomRight" title={t('generate_access_code')}>
                <Button icon={<MobileOutlined />} onClick={generateAccessCode} />
            </Tooltip>
        )
    }

    const openNotificationFailedActive = (type, who) => {
        notification.error({
            message: t('failed'),
            description:
                t('e_inactive', {type: type, what: t('org_structure').toLowerCase(), who: who}),
            placement: 'top'
        });
    };



    const changeStatus = () => {
        setWait(true);
        const formData = new FormData;
        formData.append('id', org_structure_id);
        // formData.append('status', (isActive ? 0 : 1));

        statusOrgStructure(formData)
            .then(res => {
                if (res.status === 200) {
                    setIsActive(!isActive);
                } else {
                    errorConnect()
                }
            })
            .catch((e) => {
                if (e.request.status === 403) {
                } else {
                    errorConnect()
                }
            })
            .finally(() => {
                setWait(false)
            })
    }

    const generateAccessCode = () => {
        setWait(true)


        getAccessCode(org_structure_id)
            .then(res => {
                Modal.success({
                    icon: null,
                    content: (
                        <>
                            {/*<Spin spinning={accessCode}>*/}
                            <div style={{width:'100%', textAlign:'center'}}>
                                <Typography.Text strong >{t('one_time_access_code')}</Typography.Text>
                                <Typography.Title level={2}>{res.data.access_code}</Typography.Title>
                            </div>
                            <br/>
                            {/*</Spin>*/}
                        </>
                    ),
                    // onOk() {
                    //     console.log("OK")
                    // },
                });

            })
            .catch((e) => {
                if (e.request.status === 403) {
                } else {
                    errorConnect()
                }
            })
            .finally(() => {
                setWait(false)
            })

    }


    const checkActiveWarehouse = (select_warehouses) => {
        let active = true;
        if (select_warehouses !== undefined) {
            warehouses.map(w => {
                if (select_warehouses.includes(w.id) && w.status === 0) {
                    active = false;
                }
            })
        }


        return active;
    }

    const openNotificationFalse = (action) => {
        notification.error({
            message: 'Failed',
            description:
                t('e_update_create', {action: action, type: t('org_structure').toLowerCase()}),
            placement: 'top'
        });
    };


    const onFinish = async (values) => {
        setWait(true);

        if (!checkActiveWarehouse(values['warehouses'])) {
            setWait(false);
            openNotificationFailedActive(t('save').toLowerCase(), t('warehouses').toLowerCase())
            return
        }

        const formData = new FormData();
        formData.append('name', values["name"])
        formData.append('org_structure_type_id', values["org_structure_type_id"])
        formData.append('parent_obj_id', values["parent_obj_id"] === 0 ? null : values["parent_obj_id"])

        formData.append('warehouse', isNullForm(values["warehouses"]) ? [] : values["warehouses"])

        formData.append('pattern_activity', values["pattern_activity"])
        if (org_structure_id !== 'new') {
            formData.append('id', parseInt(org_structure_id))
        }

        if (org_structure_id === 'new') {
            createOrgStructure(formData)
                .then(res => {
                    if (res.status === 200) {
                        // navigate("/org-structures", {replace: true});
                        navigate(-1)
                    } else {
                        openNotificationFalse(t('creating'));
                    }
                })
                .catch((e) => {
                    if (e.request.status === 403) {
                        setToken(null)
                    } else {
                        setWait(false)
                        errorConnect()
                    }
                })

        } else {
            updateOrgStructure(formData)
                .then(res => {
                    if (res.status === 200) {
                        // navigate(`/org-structures?${searchParams.toString()}`)
                        navigate(-1)
                    } else {
                        openNotificationFalse(t('updating'));
                    }
                })
                .catch((e) => {
                    if (e.request.status === 403) {
                        setToken(null)
                    } else {
                        setWait(false)
                        errorConnect()
                    }
                })
        }
    }

    useEffect(() => {
        window.scroll(0,0)
        axios.all([getActivePatternActivities(), getOrgStructureTypes(), getActiveWarehouses()])
            .then(axios.spread((pattern, org_types, warehouse) => {
                setPatternActivities(pattern.data);
                setOrgStructuresType(org_types.data.data);
                setWarehouses(warehouse.data);
                setIsLoadSystem(false);
                setWait(false)
            }))
            .catch((e) => {
                if (e.request.status === 403) {
                    setToken(null)
                } else {
                    setWait(false)
                    errorConnect()
                }
            });

    }, [])

    useEffect(() => {
        // if (!isLoadSystem) {
        if(org_structure_id != null) {
            setWait(true)
            getOrgStructure(org_structure_id)
                .then(res => {
                    setIsActive(res.data.status === 1);
                    res.data['warehouse'].map(w => {
                        if (w.status === 0) {
                            setWarehouses(current => [...current, w])
                        }
                    })

                    res.data['pattern_activity'].map(p => {
                        if (p.status === 0) {
                            setPatternActivities(current => [...current, p])
                        }
                    })


                    form.setFieldsValue({
                        name: res.data['name'],
                        org_structure_type_id: res.data['org_structure_type_id'],
                        parent_obj_id: res.data['parent_object_id'],
                        pattern_activity: res.data['pattern_activity'].map(p => p.id),
                        warehouses: res.data['warehouse'].map(w => w.id)
                    });
                    setUserLevel(res.data['org_structure_type_id']);
                    setWait(false);
                })
                .catch((e) => {
                    if (e.request.status === 403) {
                        setToken(null)
                    } else {
                        setWait(false)
                        errorConnect()
                    }
                })
                .finally(() => {
                    setWait(false)
                })
        }
        // }
    }, [])

    useEffect(() => {
        if (userLevel === 1) {
            setDisplayParent(false);
        } else {
            setDisplayParent(true);

            const formData = new FormData;
            formData.append('current_structure', userLevel);

            getOrgStructureParent(formData)
                .then(res => {
                    setParent(res.data)
                })
                .catch((e) => {
                    if (e.request.status === 403) {
                        setToken(null)
                    } else {
                        setWait(false)
                        errorConnect()
                    }
                });

        }
    }, [userLevel])


    return (
        <Spin spinning={wait} delay={300}>
            <div className="page">
                <Space
                    style={{
                        width: '100%',
                        justifyContent: 'space-between'
                    }}>
                    <Breadcrumb
                        style={{
                            margin: '15pt 0',
                        }}
                    >
                        <Breadcrumb.Item>
                            <span className={'ant-page-header-heading-title'} style={{paddingLeft:'24px'}}>
                                {t('org_structure')}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>

                    <Space>
                        <GeneratePinCode/>
                        <StatusButton />
                        <Divider type="vertical" style={{margin:'0 10pt'}}/>
                        <Button type={"primary"} htmlType="submit" shape={'round'} form={"form"} key='2'>{t('save')}</Button>
                        <Button
                            onClick={() => navigate(
                                `/site/org-structures?${searchParams.toString()}`,
                                {state: {data: params.data}}
                            )}
                            shape={'round'}>
                            {t('back')}
                        </Button>
                    </Space>
                </Space>



                <Space size={40} style={{display: "flex", alignItems: 'stretch'}} wrap>
                    <Form form={form}
                          style={{width: '50vh'}}
                          layout={"vertical"}
                          onFinish={onFinish}
                          autoComplete="off"
                          id={"form"}
                    >
                        <Form.Item style={{marginBottom: '10pt'}}
                                   name="name"
                                   label={t('name')}
                                   rules={[
                                       {
                                           required: true,
                                           message: t('e_input', {input: t('name').toLowerCase()}),
                                       },
                                   ]}
                                   hasFeedback
                        >
                            <Input showCount maxLength={100}/>
                        </Form.Item>

                        <Form.Item style={{marginBottom: '10pt'}}
                                   name="org_structure_type_id"
                                   label={t('org_structure_type')}
                                   rules={[
                                       {
                                           required: true,
                                           message: t('e_select', {select: t('org_structure_type').toLowerCase()}),
                                       },
                                   ]}
                                   hasFeedback
                        >
                            <Select
                                showSearch
                                onChange={e => setUserLevel(e)}
                                optionFilterProp="name"
                                optionLabelProp="name"
                                allowClear>
                                {orgStructuresType.map(u =>
                                    <Select.Option key={u.id} value={u.id} name={t(u.name)}
                                                   disabled={u.status === 0}>{t(u.name)}</Select.Option>
                                )}
                            </Select>
                        </Form.Item>

                        <Form.Item style={{marginBottom: '10pt', display: displayParent ? '' : 'none'}}
                                   name="parent_obj_id"
                                   label={t('parent')}
                                   hasFeedback
                        >
                            <Select
                                showSearch
                                optionFilterProp="name"
                                optionLabelProp="name"
                                allowClear>
                                {parent.map(u =>
                                    <Select.Option key={u.id} value={u.id} name={u.name}
                                                   disabled={u.status === 0}>{u.name}</Select.Option>
                                )}
                            </Select>
                        </Form.Item>

                        <Form.Item style={{marginBottom: '10pt'}}
                                   name="warehouses"
                                   label={t('warehouses')}
                                   hasFeedback
                        >
                            <Select
                                mode={"multiple"}
                                optionFilterProp="name"
                                optionLabelProp="name"
                                allowClear
                            >

                                {warehouses.map((warehouse) => (
                                    <Select.Option key={warehouse.id} value={warehouse.id} name={warehouse.name}
                                                   disabled={warehouse.status === 0}>{warehouse.name}</Select.Option>)
                                )}
                            </Select>
                        </Form.Item>

                        <Form.Item
                            name={"pattern_activity"}
                            label={t('pattern_activity')}
                            rules={[
                                {
                                    required: true,
                                    message: t('e_select', {select: t('pattern_activity').toLowerCase()}),
                                },
                            ]}
                            hasFeedback
                            style={{marginBottom: '10pt'}}
                        >
                            <Select
                                mode={"multiple"}
                                filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                                allowClear>
                                {patternActivities.map(pattern => {
                                        if (pattern.status !== 0) {
                                            return <Select.Option key={pattern.id} value={pattern.id}>{t(pattern.name)}</Select.Option>
                                        }
                                    }
                                )}
                            </Select>
                        </Form.Item>

                        <Form.Item style={{marginBottom: '10pt'}}>
                            <Button type={'primary'} onClick={() => setIsOpenDrawer(true)}>{t('responsibility_area')}</Button>
                        </Form.Item>
                    </Form>
                </Space>
            </div>
            <DrawerResponseOrgStructure show={isOpenDrawer} setShow={setIsOpenDrawer} token={token} org_structure_id={org_structure_id}/>
            <Outlet/>
        </Spin>
    )
}

export default EditOrgStructure